var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-item"},[_c('editor-header',{attrs:{"showSettings":false,"hasHelper":_vm.contentItem.has_helper,"title":_vm.$t('builder.dashboard_buttons')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }